import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import guestRoutes from "./routes/guestRoutes";
import authenticatedRoutes from "./routes/authenticatedRoutes";
import ReduxProvider from "./store/ReduxProvider";
import { selectIsAuthenticated } from "./store/slices/authSlice";
import WasteManagementPreloader from "./components/WasteManagementPreloader";

function AppContent() {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <WasteManagementPreloader fullScreen={true} size="default" message="Loading..." />
        }
      >
        <Routes>
          {isAuthenticated ? (
            <>
              {authenticatedRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </>
          ) : (
            <>
              {guestRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </>
          )}
        </Routes>
      </Suspense>
      <ToastContainer />
    </BrowserRouter>
  );
}

function App() {
  return (
    <ReduxProvider>
      <AppContent />
    </ReduxProvider>
  );
}

export default App;
